<script setup lang="ts">
  import { ref, onMounted, onBeforeUnmount } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  const props = defineProps<{
    items: any[]
    itemsPerSlide?: number
    autoPlayInterval?: number
    showDots?: boolean
  }>()

  const { isMobileDevice } = useBreakpoint()

  const currentSlide = ref(0)
  const intervalRef = ref<number | null>(null)

  const nextSlide = () => {
    const itemsPerSlide = props.itemsPerSlide || (isMobileDevice.value ? 1 : 2)
    currentSlide.value = (currentSlide.value + 1) % Math.ceil(props.items.length / itemsPerSlide)
  }

  const navigateToSlide = (index: number) => {
    currentSlide.value = index
    resetInterval()
  }

  const resetInterval = () => {
    if (intervalRef.value) {
      clearInterval(intervalRef.value)
    }
    intervalRef.value = window.setInterval(nextSlide, props.autoPlayInterval || 5000)
  }

  onMounted(() => {
    intervalRef.value = window.setInterval(nextSlide, props.autoPlayInterval || 5000)
  })

  onBeforeUnmount(() => {
    if (intervalRef.value) {
      clearInterval(intervalRef.value)
    }
  })
</script>

<template lang="pug">
.slider-wrapper
  .slider-container(:style='{ transform: `translateX(-${currentSlide * 100}%)` }')
    slot
  .slider-dots(v-if='showDots')
    button.dot(
      v-for='index in Math.ceil(items.length / (itemsPerSlide || (isMobileDevice ? 1 : 2)))',
      :key='index',
      :class='{ active: index - 1 === currentSlide }',
      @click='navigateToSlide(index - 1)'
    )
</template>

<style lang="postcss" scoped>
  .slider-wrapper {
    @apply ketch-relative ketch-overflow-hidden;

    .slider-container {
      @apply ketch-flex ketch-transition-transform ketch-duration-500 ketch-ease-in-out;
    }

    .slider-dots {
      @apply ketch-flex ketch-justify-center ketch-space-x-c10 ketch-mt-c20;

      .dot {
        @apply ketch-w-[6px] ketch-h-[6px] ketch-rounded-full ketch-bg-white/30 ketch-transition-colors;
        @apply sm:ketch-w-[12px] sm:ketch-h-[12px];

        &.active {
          @apply ketch-bg-white;
        }
      }
    }
  }
</style>
